import { render, staticRenderFns } from "./THVBVSGT.vue?vue&type=template&id=b5c2dd6a&scoped=true&"
import script from "./THVBVSGT.vue?vue&type=script&lang=js&"
export * from "./THVBVSGT.vue?vue&type=script&lang=js&"
import style0 from "./THVBVSGT.vue?vue&type=style&index=0&id=b5c2dd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c2dd6a",
  null
  
)

export default component.exports